import StatsDebtorsHeader from "../StatsDebtorsHeader/StatsDebtorsHeader";
import StatsDebtorsListing from "../StatsDebtorsListing/StatsDebtorsListing";

export default function StatsDebtors() {
    return (
        <section>
            <StatsDebtorsHeader />
            <StatsDebtorsListing />
        </section>
    );
}
